import { addNewLocation } from 'src/components/enterprise/features/Locations/api/locationsApi';
import { useSendAnalytics } from 'src/components/AnalyticsProvider/useSendAnalytics';
import { ILocation } from 'src/types/Location';
import { pushErrorFromAPI, pushSuccess } from 'src/utilities/notifications';
import { SHORT_SEARCH_DELAY } from 'src/utilities/useSearchHooks';

export interface UseAddNewLocationReturn {
  addLocation: (locationData: Partial<ILocation>) => Promise<void>;
}

export interface UseAddNewLocationProps {
  corpId: string;
  onSuccess: () => void;
}

export const useAddNewLocation = ({
  corpId,
  onSuccess,
}: UseAddNewLocationProps): UseAddNewLocationReturn => {
  const { sendAnalytics } = useSendAnalytics({
    eventcategory: 'corp admin_location',
    eventaction: 'add new location',
  });

  async function addLocation(locationData: Partial<ILocation>): Promise<void> {
    try {
      await addNewLocation({
        corpId,
        newLocation: locationData,
      });
      await new Promise<void>((resolve) => {
        setTimeout(() => {
          onSuccess();
          sendAnalytics();
          pushSuccess('Your location was added');
          resolve();
        }, SHORT_SEARCH_DELAY);
      });
    } catch (error) {
      pushErrorFromAPI(error, {
        fallbackMessage: 'Your location was not added. Try again.',
      });
    }
  }

  return {
    addLocation,
  };
};
